class VtagzPopup extends HTMLElement {
  constructor() {
    super();

    // Check if user has previously closed the popup
    if (localStorage.getItem('vtagzPopupClosed')) {
      this.remove();
      return;
    }

    // Delay popup appearance
    setTimeout(() => {
      this.style.display = 'block';
      Shopify.analytics.publish('vtagz_form_viewed', {
        vtagz_form_viewed: true,
      });
    }, this.dataset.delay);
  }

  connectedCallback() {
    // Initially hide the popup
    this.style.display = 'none';

    const closeButton = this.querySelector('.popup-close');
    // Handle close button click
    if (closeButton) {
      closeButton.addEventListener('click', () => {
        localStorage.setItem('vtagzPopupClosed', 'true');
        this.remove();
      });
    }

    // The SMS marketing consent checkbox (#smsConsentCheckbox) inside the nested
    // vtagz-phone-form block is optional and no longer gates the sign-up button
    // (Marketing Opt-In Consent Update, Asana 1217785661793184).
  }
}

customElements.define('vtagz-popup', VtagzPopup);
